import { PageType } from "__generated__/globalTypes";

export enum CategoryPage {
  Plp = "PLP",
  Clp = "CLP",
}

export type DetailedPageType = PageType | CategoryPage;
